import { render, staticRenderFns } from "./ModalAdvancedStyles.vue?vue&type=template&id=687dd70f&"
import script from "./ModalAdvancedStyles.vue?vue&type=script&lang=js&"
export * from "./ModalAdvancedStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
